// Central warranty resolver — Signia India warranty length varies by tier.
// Per HearClear policy (2026): 5IX & 7IX ship with an extended 4-year warranty;
// all other Styletto IX/AX tiers ship with the standard 3-year.
export function warrantyYearsFor(product) {
    if (!product) return 3;
    const s = (product.slug || "").toLowerCase();
    const t = (product.technology_level || "").toLowerCase();
    if (s.includes("5ix") || s.includes("7ix") || t.includes("premium") || t.includes("flagship")) {
        return 4;
    }
    return 3;
}

export function warrantyLabelFor(product) {
    return `${warrantyYearsFor(product)}-year Signia India warranty`;
}
